import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: 'filtroAspirante'
})

export class FilterAspirante implements PipeTransform {

    transform(value:any,arg:any):any{

        const resultPosts = [];

        for(const aspirante of value){
            if(aspirante.nombre.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                resultPosts.push(aspirante);
            }
            else if(aspirante.apellidoPaterno.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                resultPosts.push(aspirante);
            }
            else if(aspirante.apellidoMaterno.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                resultPosts.push(aspirante);
            }


        };

        return resultPosts;

    }


}